<template>
    <div class="Proyectos">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="2" :url="url"/>

        <div class="container-fluid">
            
            <!--Headers-->
            <div v-if="rol==1">
                <div class="row">
                    <div class="col-sm-6">
                        <h3 class="pt-3">Mis Proyectos</h3>
                    </div>
                    <div class="col-sm-6">
                        <div class="pt-3">
                            <router-link class="btn orange float-right" to="NuevoProyecto">
                                <font-icon icon="plus"/> Crear Proyecto
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-sm-6">
                        <h3 class="pt-3">Mis Propuestas</h3>
                    </div>
                </div>
            </div>
            
            <!--Sub Menu-->
            <div v-if="rol==1">
                <div class="row pt-5">
                    <div class="col-sm-12">
                        <a class="pointer" :class="{notActive: active != 1,linkActive: active == 1}" @click="paginador(1)">
                            Draft <span class="badge badge-primary" v-show="totalDraft != 0">{{totalDraft}}</span> 
                        </a>
                        <a class="pointer" :class="{notActive: active != 2,linkActive: active == 2}" @click="paginador(2)">
                            Publicados <span class="badge badge-primary" v-show="totalPublicadas != 0">{{totalPublicadas}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 3,linkActive: active == 3}" @click="paginador(3)">
                            En Progreso <span class="badge badge-primary" v-show="totalProgreso != 0">{{totalProgreso}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 6,linkActive: active == 6}" @click="paginador(6)">
                            Pausados <span class="badge badge-primary" v-show="totalPausados != 0">{{totalPausados}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 7,linkActive: active == 7}" @click="paginador(7)">
                            Cancelados <span class="badge badge-primary" v-show="totalCancelados != 0">{{totalCancelados}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 5,linkActive: active == 5}" @click="paginador(5)">
                            Terminados <span class="badge badge-primary" v-show="totalTerminado != 0">{{totalTerminado}}</span>
                        </a>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="row pt-5 pb-3">
                    <div class="col-sm-12">
                        <a class="pointer" :class="{notActive: active != 1,linkActive: active == 1}" @click="paginador(1)">
                            Enviadas <span class="badge badge-primary" v-show="totalEnviada != 0">{{totalEnviada}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 2,linkActive: active == 2}" @click="paginador(2)">
                            Ganadas <span class="badge badge-primary" v-show="totalGanada != 0">{{totalGanada}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 3,linkActive: active == 3}" @click="paginador(3)">
                            Perdidas <span class="badge badge-primary" v-show="totalPerdido != 0">{{totalPerdido}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 5,linkActive: active == 5}" @click="paginador(5)">
                            Canceladas <span class="badge badge-primary" v-show="totalCancelados != 0">{{totalCancelados}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 6,linkActive: active == 6}" @click="paginador(6)">
                            Vencidas <span class="badge badge-primary" v-show="totalVencidas != 0">{{totalVencidas}}</span>
                        </a>
                        <a class="pointer" :class="{notActive: active != 8,linkActive: active == 8}" @click="paginador(8)">
                            Terminadas <span class="badge badge-primary" v-show="totalTerminado != 0">{{totalTerminado}}</span>
                        </a>
                    </div>
                </div>
            </div>
            
            <div>
                <div class="pt-3">
                    <div v-if="rol==0"> <!--Tabla Consultor -->
                        <div v-if="tabla == 1">
                            <Enviadas @update="getDataConsultor" />
                        </div>
                        <div v-if="tabla == 2">
                            <Ganadas @update="getDataConsultor"/>
                        </div>
                        <div v-if="tabla == 3">
                            <Perdidas />
                        </div>
                        <div v-if="tabla == 5">
                            <Canceladas />
                        </div>
                        <div v-if="tabla == 6">
                            <Vencidas />
                        </div>
                        <div v-if="tabla == 8">
                            <Terminadas />
                        </div>
                    </div>
                    
                    <div class="pt-3" v-else> <!---Tabla Empresas-->
                        <div v-if="tabla == 1">
                            <Draft @update="getDataEmpresa"/>
                        </div>
                        <div v-if="tabla == 2">
                            <Publicadas @update="getDataEmpresa" />
                        </div>
                        <div v-if="tabla == 3">
                            <EnProgreso @update="getDataEmpresa" />
                        </div>
                        <div v-if="tabla ==6">
                            <Pausados @update="getDataEmpresa" />
                        </div>
                        <div v-if="tabla ==7">
                            <CanceladosEmp @update="getDataEmpresa" />
                        </div>
                        <div v-if="tabla == 5">
                            <TerminadosEmp @update="getDataEmpresa" />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'
import StarRating from 'vue-star-rating'
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
/*Local Components*/
import Enviadas from './components/Consultor/Enviadas'
import Ganadas from './components/Consultor/Ganadas'
import Perdidas from './components/Consultor/Perdidas'
import Canceladas from './components/Consultor/Canceladas'
import Vencidas from './components/Consultor/Vencidas'
import Terminadas from './components/Consultor/Terminadas'

import Draft from './components/Empresa/Draft'
import Publicadas from './components/Empresa/Publicadas'
import EnProgreso from './components/Empresa/EnProgreso'
import Pausados from './components/Empresa/Pausados'
import CanceladosEmp from './components/Empresa/Cancelados'
import TerminadosEmp from './components/Empresa/TerminadosEmp'

export default {
name: 'Proyectos',
components:{
    Submenu,Menu,StarRating, Enviadas, Ganadas, Perdidas, Canceladas, Vencidas, Terminadas, 
    Draft, Publicadas, EnProgreso, Pausados, CanceladosEmp, TerminadosEmp
},
mixins: [ globalFunctions ],
data () {
    return {
        rol: localStorage.rol,
        sesion: false,
        status: false,
        active: 1,
        tabla: 0,
        totalEnviada: '',
        totalGanada: '',
        totalTerminado: '',
        totalPerdido: '',
        totalCancelados: '',
        totalVencidas: '',
        totalProgreso : '',
        totalTerminado: '',
        totalPausados: '',
        totalCancelados: '',
        totalPublicadas: '',
        totalDraft: ''
    }
},
computed:{
    ...mapState(['url'])
},
methods:{
paginador(i){
    this.tabla = i;
    this.active = i;   
},
getDataConsultor(){

    let data = {
        id: localStorage.userID,
        flag:5
    };

    this.axios.post(this.url + 'consultasBasicas.php',data).then((responce) =>{
        if(responce.data != null){
            this.totalEnviada = responce.data[0].Enviado;
            this.totalGanada = Number(responce.data[0].Ganada) + Number(responce.data[0].Concluido);
            this.totalTerminado = responce.data[0].Pagada;
            this.totalPerdido = responce.data[0].Perdida;
            this.totalCancelados = responce.data[0].Cancelada;
            this.totalVencidas = responce.data[0].Vencida;
        }else{
            this.totalEnviada = 0;
        }
        
    });
},
getDataEmpresa(){
    let data1 = {
        id: localStorage.userID,
        flag: 4,
    };

    this.axios.post(this.url + 'consultasBasicas.php',data1).then((responce) =>{
        this.totalDraft = responce.data.Draft;
        this.totalPublicadas = responce.data.Publicada;
        
        let uno = responce.data.Asignado;
        let dos = responce.data.Fondeada;
        let tres = responce.data.Concluido;

        this.totalProgreso = Number(dos) + Number(uno) + Number(tres);
        this.totalTerminado = responce.data.Finished;
        this.totalPausados = responce.data.Suspendia;
        this.totalCancelados = responce.data.Cancelada;
    });
}
},
mounted(){

    let pagina = this.$route.query.tabla;
    
    if(pagina == undefined){
        pagina = 1;
    }
    
    this.paginador(pagina);

    if(this.rol ==0){ //Consultor
        this.getDataConsultor();
    }
    else{ //EMPRESA
        this.getDataEmpresa();
    }

    //check
    let resp = this.checkUser();
    this.sesion = resp;
}
}
</script>


<style scoped>
.spinner-border{
    color: #ff200b;
}

.linkActive{
    color: black;
    font-weight: bold;
    border-bottom: 2px solid #0f99f0;
    text-decoration: none;
    padding: 8px 16px 16px 8px;
}

.notActive
{
    color:black;
    text-decoration: none;
    padding: 8px 16px 16px 8px;
}

.notActive:hover{
    color: black;
    border-bottom: 2px solid #d1cbcb;
}
</style>


// WEBPACK FOOTER //
// src/views/Proyectos/Proyectos.vue